module.exports = __webpack_public_path__ + "img/jcps-logo.ed75c62a.png";